<template lang="html">
  <div class="fill-height">
    <v-app-bar app flat color="white" height="72">
      <v-container class="px-0">
        <v-row>
          <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
            <div class="d-flex align-center">
              <template v-if="selectedOutlet && selectedOutlet.logo">
                <div class="store-logo-image">
                  <img :src="selectedOutlet.logo" :alt="selectedOutlet.name">
                </div>
              </template>
              <v-spacer />
              <div class="d-flex align-center">
                <div>
                  <locale />
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>
    <div class="banner-splash" :style="{ backgroundImage: 'url(' + image + ')', height: 'calc(25% - 72px)' }" />
    <div class="container-banner-splash">
      <div class="logo-banner-splash">
        <template v-if="selectedOutlet">
          <img :src="selectedOutlet.logo" :alt="selectedOutlet.name" class="img-banner-splash">
        </template>
      </div>
    </div>
    <v-container>
      <v-row>
        <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
          <div class="text-center">
            <div class="title-splash">
              {{ $t('v2.welcome') }}
            </div>
            <div class="mt-1 subtitle-splash">
              {{ $t('v2.where_do_you_want_to_order') }}
            </div>
          </div>
          <div v-if="!allow_location" class="mt-4">
            <div class="warning-gps">
              <div class="wrap-warning-gps">
                <div class="warning-gps-icon">
                  <img src="@/assets/images/v2/img/icon_warning_gps.png" alt="Warning">
                </div>
                <div class="warning-gps-content">
                  <div class="warning-gps-title">
                    {{ $t('v2.distance_store') }}
                  </div>
                </div>
                <div class="warning-gps-action">
                  <div class="warning-gps-action-allow" @click="checkPermission()">
                    {{ $t('v2.allow') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-4 mb-8">
            <outlet-selection v-model="store_id" :params="params_outlet" @select-outlet="selectOutlet" />
          </div>
          <div :style="{ marginBottom: marginMenuBottom + 'px' }">
            <div v-if="selectedOutlet.setting && !$isEmpty(selectedOutlet.setting) && !selectedOutlet.setting.use_takeaway && !selectedOutlet.setting.use_delivery && !selectedOutlet.setting.use_reservation && !selectedOutlet.setting.use_place_reservation" class="text-center">
              <div>
                <img src="@/assets/images/v2/img/no_data_order.png" alt="No data" width="100%" class="mb-2">
              </div>
              <div class="font-18 font-weight-700 mx-auto mb-6" style="max-width: 312px;">
                {{ $t('v2.no_services_are_available') }}
              </div>
            </div>
            <template v-else>
              <div class="font-18 font-weight-bold">
                {{ $t('v2.select_service') }}
              </div>
              <div class="v2-list-services">
                <div v-if="selectedOutlet.setting && !$isEmpty(selectedOutlet.setting) && selectedOutlet.setting.use_takeaway === 1" :class="[`v2-list-item-services`, { 'active': form.remark === 'OL-TAKE-AWAY' }]" @click="selectRemark(1)">
                  <div class="v2-list-item-avatar-services">
                    <img src="@/assets/images/v2/img/icon_takeaway.png" :alt="$t('v2.takeaway')">
                  </div>
                  <div class="v2-list-item-content-services">
                    <div class="v2-list-item-title-services">
                      {{ $t('v2.takeaway') }}
                    </div>
                  </div>
                  <div class="v2-list-item-action-services">
                    <div :class="[`v2-list-item-action-select`, { 'active': form.remark === 'OL-TAKE-AWAY' }]">
                      <div class="v2-list-item-action-select-value" />
                    </div>
                  </div>
                </div>
                <div v-if="selectedOutlet.setting && !$isEmpty(selectedOutlet.setting) && selectedOutlet.setting.use_delivery === 1" :class="[`v2-list-item-services`, { 'active': form.remark === 'DELIVERY' }]" @click="selectRemark(2)">
                  <div class="v2-list-item-avatar-services">
                    <img src="@/assets/images/v2/img/icon_delivery.png" :alt="$t('v2.delivery')">
                  </div>
                  <div class="v2-list-item-content-services">
                    <div class="v2-list-item-title-services">
                      {{ $t('v2.delivery') }}
                    </div>
                    <div v-if="!allow_location" class="v2-list-item-subtitle-services">
                      {{ $t('v2.allow_gps_for_delivery') }}
                    </div>
                  </div>
                  <div class="v2-list-item-action-services">
                    <div :class="[`v2-list-item-action-select`, { 'active': form.remark === 'DELIVERY' }]">
                      <div class="v2-list-item-action-select-value" />
                    </div>
                  </div>
                </div>
                <div v-if="selectedOutlet.setting && !$isEmpty(selectedOutlet.setting) && selectedOutlet.setting.use_reservation === 1" :class="[`v2-list-item-services`, { 'active': form.remark === 'RESERVATION' }]" @click="selectRemark(3)">
                  <div class="v2-list-item-avatar-services">
                    <img src="@/assets/images/v2/img/icon_reservation.png" :alt="$t('v2.food_reservation')">
                  </div>
                  <div class="v2-list-item-content-services">
                    <div class="v2-list-item-title-services">
                      {{ $t('v2.food_reservation') }}
                    </div>
                  </div>
                  <div class="v2-list-item-action-services">
                    <div :class="[`v2-list-item-action-select`, { 'active': form.remark === 'RESERVATION' }]">
                      <div class="v2-list-item-action-select-value" />
                    </div>
                  </div>
                </div>
                <div v-if="selectedOutlet.setting && !$isEmpty(selectedOutlet.setting) && selectedOutlet.setting.use_place_reservation === 1" :class="[`v2-list-item-services`, { 'active': form.remark === 'TABLE_RESERVATION' }]" @click="selectRemark(4)">
                  <div class="v2-list-item-avatar-services">
                    <img src="@/assets/images/v2/img/icon_reservationv2.png" :alt="$t('v2.table_reservation')">
                  </div>
                  <div class="v2-list-item-content-services">
                    <div class="v2-list-item-title-services">
                      {{ $t('v2.table_reservation') }}
                    </div>
                  </div>
                  <div class="mr-6 tag-new">
                    {{ $t('v2.new') }}
                  </div>
                  <div class="v2-list-item-action-services">
                    <div :class="[`v2-list-item-action-select`, { 'active': form.remark === 'TABLE_RESERVATION' }]">
                      <div class="v2-list-item-action-select-value" />
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <div class="olsera-brand mt-4 text-center">
              <div class="font-12 ol-grey-content font-weight-400" style="margin-bottom: 6px;">
                powered by
              </div>
              <div>
                <a href="https://www.olsera.com/id/online" target="_blank" rel="noopener noreferrer">
                  <img src="@/assets/images/olsera_logo.png" alt="Olsera.com" width="76">
                </a>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <div v-if="selectedOutlet.setting.use_takeaway || selectedOutlet.setting.use_delivery || selectedOutlet.setting.use_reservation || selectedOutlet.setting.use_place_reservation" ref="refMenuBottom" class="fixed-bottom">
      <v-container>
        <v-row>
          <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="py-0">
            <v-btn block color="v2_primary" :disabled="disabledNext" height="40" class="br-5 text-none white--text font-16 font-weight-bold btn-v2-shadow" @click="goToMenu()">
              {{ $t('v2.menu') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <v-dialog v-model="dialog.confirm" max-width="350">
      <v-card class="br-10">
        <div class="pa-4">
          <div class="text-center font-18 font-weight-700 mb-2">
            {{ $t('v2.move_to_outlet', { outlet: temp_outlet.name }) }}
          </div>
          <div class="font-14 mb-4 font-weight-400 ol-black text-center line-height-normal">
            {{ $t('v2.selected_menu_from_previous') }}
          </div>
          <div class="card-action-button">
            <div class="card-action-item-button">
              <v-btn block color="white" height="40" class="text-none font-weight-700 ol-black letter-spacing-normal ol-elevation-1 br-5" @click="dialog.confirm = false">
                {{ $t('v2.cancel3') }}
              </v-btn>
            </div>
            <div class="card-action-item-button">
              <v-btn block color="olbrand" height="40" class="text-none font-weight-700 white--text letter-spacing-normal ol-elevation-1 br-5" @click="changeStore()">
                {{ $t('v2.yes_next') }}
              </v-btn>
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Locale from '@/components/v2/Locale'
import OutletSelection from '@/components/v2/OutletSelection'
export default {
  components: {
    Locale,
    OutletSelection
  },
  data() {
    return {
      dialog: {
        confirm: false
      },
      image: require('@/assets/images/v2/img/background_banner.png'),
      outlets: [],
      margin_menu_bottom: 0,
      form: {
        remark: ''
      },
      params_outlet: {
        origin_lat: 0,
        origin_lon: 0
      },
      allow_to_menu: false,
      allow_location: false,
      store_id: {
        id: null,
        url: ''
      },
      cart: {},
      previousService: '',
      previousStoreId: '',
      temp_outlet: {}
    }
  },
  computed: {
    marginMenuBottom() {
      return this.margin_menu_bottom
    },
    disabledNext() {
      if (this.form.remark !== '') {
        return false
      } else {
        return true
      }
    },
    selectedOutlet() {
      return this.$store.state.selected_outlet
    }
  },
  mounted() {
    this.store_id.id = this.$store.state.selected_outlet.id
    this.store_id.url = this.$store.state.selected_outlet.url_id
    this.margin_menu_bottom = this.$refs.refMenuBottom.clientHeight
    const LOCAL_DATA_CART = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_cart')
    if (LOCAL_DATA_CART) {
      this.cart = JSON.parse(LOCAL_DATA_CART)
    }
    const PREVIOUS_SERVICE = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_selected_type')
    if (PREVIOUS_SERVICE) {
      this.previousService = JSON.parse(PREVIOUS_SERVICE)
    }
    const PREVIOUS_STORE_ID = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_selected_id')
    if (PREVIOUS_STORE_ID) {
      this.previousStoreId = Number(PREVIOUS_STORE_ID)
    }
    // this.getOutlet()
    this.checkPermission()
  },
  methods: {
    async checkPermission() {
      if (navigator.geolocation) {
        await navigator.geolocation.getCurrentPosition(this.successPosition, this.failurePosition, {
          enableHighAccuracy: true,
          timeout: 5000
        })
      } else {
        alert(`Browser doesn't support Geolocation`)
      }
    },
    successPosition: async function(position) {
      this.allow_location = true
      this.params_outlet.origin_lat = position.coords.latitude
      this.params_outlet.origin_lon = position.coords.longitude
      // this.getOutlet()
    },
    failurePosition() {
      this.allow_location = false
      console.log('failure')
    },
    selectRemark(type) {
      if (type === 1) {
        this.form.remark = 'OL-TAKE-AWAY'
        this.allow_to_menu = true
      } else if (type === 2) {
        this.form.remark = 'DELIVERY'
        if (this.allow_location) {
          this.allow_to_menu = true
        } else {
          this.allow_to_menu = false
        }
      } else if (type === 3) {
        this.form.remark = 'RESERVATION'
        this.allow_to_menu = true
      } else if (type === 4) {
        this.form.remark = 'TABLE_RESERVATION'
        this.allow_to_menu = true
      }
    },
    async goToMenu() {
      if (this.allow_to_menu) {
        let cart = {
          item: []
        }
        if (this.previousService === this.form.remark && this.previousStoreId === Number(this.store_id.id)) {
          cart = { ...this.cart }
        } else if (this.previousStoreId === Number(this.store_id.id)) {
          if (typeof this.cart.item === 'undefined' || this.$isEmpty(this.cart.item)) {
            cart.item = []
          } else {
            cart.item = this.cart.item
          }
        }

        const obj = {
          url_id: this.store_id.url_id,
          id: Number(this.store_id.id)
        }
        this.$store.dispatch('saveCartV2', cart)
        this.$store.dispatch('saveSelectedType', this.form.remark)
        await this.$store.dispatch('fetchOutlet', obj)
        await this.$store.dispatch('saveSelectedId', Number(this.store_id.id))
        if (this.form.remark === 'RESERVATION') {
          this.$router.push({ name: '_reservation_detail' }).catch(() => {})
        } else {
          this.$router.push({ name: '_menu' }).catch(() => {})
        }
      } else {
        this.$store.state.show_error = true
        this.$store.state.error_message = this.$t('v2.activate_gps_for_delivery')
        this.$store.state.error_type = 400
      }
    },
    selectOutlet(item) {
      this.temp_outlet = item
      this.dialog.confirm = true
    },
    async changeStore() {
      const obj = {
        url_id: this.temp_outlet.url_id,
        id: Number(this.temp_outlet.id)
      }
      this.store_id = obj
      await this.$store.dispatch('fetchOutlet', obj)
      await this.$store.dispatch('saveSelectedId', Number(this.temp_outlet.id))
      this.dialog.confirm = false
    }
  }
}
</script>
